import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, DollarSign, Truck } from 'lucide-react';
export function RecentShipments() {
  const shipments = [{
    rv: "40' Class A Motorhome",
    route: 'Phoenix, AZ → Denver, CO',
    price: '$1,950',
    img: 'https://images.unsplash.com/photo-1523987355523-c7b5b0dd90a7?q=80&w=600&auto=format&fit=crop'
  }, {
    rv: "32' Travel Trailer",
    route: 'Dallas, TX → Nashville, TN',
    price: '$1,280',
    img: 'https://images.unsplash.com/photo-1563385150878-522648d0b27e?q=80&w=600&auto=format&fit=crop'
  }, {
    rv: "38' Fifth Wheel",
    route: 'Orlando, FL → Austin, TX',
    price: '$1,640',
    img: 'https://images.unsplash.com/photo-1559405886-c4e11649c065?q=80&w=600&auto=format&fit=crop'
  }, {
    rv: "26' Class C",
    route: 'Las Vegas, NV → Portland, OR',
    price: '$1,420',
    img: 'https://images.unsplash.com/photo-1513311068348-19c8fbdc0bb6?q=80&w=600&auto=format&fit=crop'
  }];
  return <section className="py-20 bg-slate-50" data-id="element-269">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-270">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-271">
          <h2 className="text-3xl md:text-4xl font-black text-brand-navy mb-4" data-id="element-272">
            Recent RV Shipments
          </h2>
          <p className="text-lg text-slate-600" data-id="element-273">
            Real examples of our nationwide RV transport services. We provide
            transparent, competitive RV hauling quotes for motorhomes and
            trailers of all sizes.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-274">
          {shipments.map((shipment, index) => <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} key={index} className="bg-white rounded-xl overflow-hidden shadow-md border border-slate-100 hover:shadow-xl transition-shadow" data-id="element-275">
              <div className="h-40 overflow-hidden" data-id="element-276">
                <img src={shipment.img} alt={`${shipment.rv} transport`} className="w-full h-full object-cover" data-id="element-277" />
              </div>
              <div className="p-5 space-y-3" data-id="element-278">
                <div className="flex items-center gap-2 text-brand-navy font-bold text-lg" data-id="element-279">
                  <Truck className="w-5 h-5 text-brand-red" data-id="element-280" />
                  {shipment.rv}
                </div>
                <div className="flex items-start gap-2 text-sm text-slate-600" data-id="element-281">
                  <MapPin className="w-4 h-4 text-slate-400 mt-0.5 shrink-0" data-id="element-282" />
                  <span data-id="element-283">{shipment.route}</span>
                </div>
                <div className="flex items-center gap-2 text-brand-navy font-black text-xl pt-2 border-t border-slate-100" data-id="element-284">
                  <DollarSign className="w-5 h-5 text-green-600" data-id="element-285" />
                  {shipment.price}
                </div>
              </div>
            </motion.div>)}
        </div>
        <p className="text-xs text-slate-400 text-center mt-8" data-id="element-286">
          * Prices shown are real-world examples. Actual RV shipping costs vary
          based on exact dimensions, route, season, and current fuel prices.
        </p>
      </div>
    </section>;
}